import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { sdkTouchOptimizedStyles } from "scmp-sdk/components/follow-button/styles";

import BookmarkIconOff from "./bookmark-icon-off.svg";
import BookmarkIconOn from "./bookmark-icon-on.svg";

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 30px;
  block-size: 30px;
  padding: 7.5px;

  color: inherit;
  font: inherit;

  border: none;

  background-color: transparent;

  cursor: pointer;

  ${sdkTouchOptimizedStyles}
`;

const iconStyles = css`
  inline-size: 100%;
  block-size: 100%;
`;

// #4585ff

// #001246
export const StyledBookmarkIconOff = styled(BookmarkIconOff)`
  ${iconStyles}
`;

// #4585ff
// #4585ff

export const StyledBookmarkIconOn = styled(BookmarkIconOn)`
  ${iconStyles}
`;
